/* bs-product-hero — comportamiento del hero de producto.
   Scoped por instancia (R44-48, R56). Re-init en shopify:section:load (Customizer).

   INCREMENTO 1: galería (swap de imagen principal).
   TANDA 1: selector de variante, stepper cantidad (B2B quantity_rule), botón add-to-cart
   (el submit lo intercepta <product-form-component> de Horizon → cart drawer), checkbox
   IVA 4% (line item property). formatMoney replica el money_format de la tienda.

   TANDA 2: carrusel de reseñas (initReviews) — alterna el slide visible; lightbox de
   vídeo (initVideoLightbox) — portala el modal a document.body, clona el <template>
   del media pulsado y controla play/pause + foco + escape.

   TANDA 3: modal "Asistente de medidas" (initMeasureModal) — mismo patrón de portal +
   foco atrapado + escape que initVideoLightbox, con fade/scale de entrada-salida.

   TODO: trigger real del chat de Asistente IA, y cablear Judge.me (reseñas reales +
   aggregateRating) en lugar del placeholder. */
(function () {
  'use strict';

  // ── Fecha de entrega estimada. Se calcula en el NAVEGADOR (no en Liquid) porque Shopify
  //    cachea el HTML de la sección: una fecha con {{ 'now' | date }} saldría congelada.
  //    Suma días de PREPARACIÓN (metacampo del producto) + TRANSPORTE (setting), saltando
  //    fines de semana si son laborables. Nombres en español (getDay 0=domingo).
  //    Los nombres de día y mes y las frases vienen en data-i18n-* desde Liquid, que los
  //    saca de los archivos de idioma. Los valores de aquí son solo el respaldo si el
  //    atributo faltara (getDay 0=domingo).
  var BS_WD = ['dom.', 'lun.', 'mar.', 'mié.', 'jue.', 'vie.', 'sáb.'];
  var BS_MO = ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sep.', 'oct.', 'nov.', 'dic.'];
  var BS_TMPL_BETWEEN = 'recíbelo entre el %FROM% y el %TO%';
  var BS_TMPL_ON = 'recíbelo el %DATE%';
  var BS_TMPL_DAY_MONTH = '%DAY% de %MONTH%';

  function bsAddDays(date, n, businessOnly) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (!businessOnly || (wd !== 0 && wd !== 6)) added++;
    }
    return d;
  }

  // Lee un texto traducido del elemento; si no está, usa el respaldo en español.
  function bsI18n(el, attr, fallback) {
    var v = el && el.getAttribute('data-i18n-' + attr);
    return v ? v : fallback;
  }

  function bsFmtDay(d, withMonth, i18n) {
    var s = i18n.wd[d.getDay()] + ' ' + d.getDate();
    if (withMonth) s = i18n.dayMonth.replace('%DAY%', s).replace('%MONTH%', i18n.mo[d.getMonth()]);
    // Fecha en su propio span: va en negrita, mientras el conectivo ("recíbelo entre el",
    // "y el") queda en peso 400. Se inserta con innerHTML (contenido propio, sin input de usuario).
    return '<span class="bs-product-hero__stock-date">' + s + '</span>';
  }

  // "recíbelo entre el lun. 22 y el mar. 23 de jun." (o "recíbelo el ..." si es un solo día).
  // En portugués: "receba entre seg. 22 e ter. 23 de jun.".
  function bsDeliveryText(el) {
    var prep = parseInt(el.getAttribute('data-prep-days'), 10);
    var tmin = parseInt(el.getAttribute('data-transit-min'), 10);
    var tmax = parseInt(el.getAttribute('data-transit-max'), 10);
    if (isNaN(prep) || isNaN(tmin) || isNaN(tmax)) return '';
    var business = el.getAttribute('data-business-days') !== 'false';
    var i18n = {
      wd: bsI18n(el, 'weekdays', BS_WD.join(',')).split(','),
      mo: bsI18n(el, 'months', BS_MO.join(',')).split(','),
      dayMonth: bsI18n(el, 'date-day-month', BS_TMPL_DAY_MONTH),
    };
    var today = new Date();
    var from = bsAddDays(today, prep + tmin, business);
    var to = bsAddDays(today, prep + tmax, business);
    if (from.getTime() === to.getTime()) {
      return bsI18n(el, 'delivery-on', BS_TMPL_ON).replace('%DATE%', bsFmtDay(to, true, i18n));
    }
    var sameMonth = from.getMonth() === to.getMonth();
    return bsI18n(el, 'delivery-between', BS_TMPL_BETWEEN)
      .replace('%FROM%', bsFmtDay(from, !sameMonth, i18n))
      .replace('%TO%', bsFmtDay(to, true, i18n));
  }

  // Formato de moneda equivalente al filtro `money` de Liquid (usa shop.money_format).
  function formatMoney(cents, format) {
    var formatString = format || '{{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts.length > 1 ? decimal + parts[1] : '';
      return whole + frac;
    }

    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  // ===== Galería: swap de imagen principal al pulsar un thumbnail. =====
  // openVideo (de initVideoLightbox) es opcional: si el thumb es de vídeo, no hacemos
  // swap de póster, abrimos el lightbox con el media id del propio thumb.
  function initGallery(container, openVideo) {
    var mainImage = container.querySelector('.bs-product-hero__gallery-image');
    var thumbs = container.querySelectorAll('.bs-product-hero__thumb');
    if (!mainImage || thumbs.length === 0) return;

    function selectThumb(thumb) {
      var mediaType = thumb.getAttribute('data-media-type');
      var isVideoThumb = mediaType === 'video' || mediaType === 'external_video';
      if (isVideoThumb) {
        if (typeof openVideo === 'function') {
          openVideo(thumb.getAttribute('data-bs-video-open'), thumb);
        }
        return;
      }

      var fullSrc = thumb.getAttribute('data-full-src');
      if (fullSrc) {
        // Al hacer swap limpiamos srcset para que gane el nuevo src.
        mainImage.removeAttribute('srcset');
        mainImage.setAttribute('src', fullSrc);
      }
      for (var i = 0; i < thumbs.length; i++) {
        var isActive = thumbs[i] === thumb;
        thumbs[i].classList.toggle('bs-product-hero__thumb--selected', isActive);
        if (isActive) {
          thumbs[i].setAttribute('aria-current', 'true');
        } else {
          thumbs[i].removeAttribute('aria-current');
        }
      }
    }

    for (var j = 0; j < thumbs.length; j++) {
      thumbs[j].addEventListener('click', function () {
        selectThumb(this);
      });
    }
  }

  // ===== Buy-box: variante + cantidad + botón + IVA. =====
  function initBuyBox(container) {
    var dataEl = container.querySelector('[data-bs-hero-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!data || !data.variants) return;

    var variantsById = {};
    for (var v = 0; v < data.variants.length; v++) {
      variantsById[String(data.variants[v].id)] = data.variants[v];
    }
    var moneyFormat = data.money_format || '{{amount}}';

    // Elementos (todos opcionales según lo que renderice el server).
    var variantOptions = container.querySelectorAll('[data-bs-variant-option]');
    var variantCurrents = container.querySelectorAll('[data-bs-variant-current]');
    var variantIdInput = container.querySelector('input[name="id"]');

    // Selección actual por opción: selectedOptions[posición 1..3] = valor. Se inicializa desde las
    // pills que el server marcó como seleccionadas (una por opción). La variante se resuelve por la
    // COMBINACIÓN de estos valores (resolveVariant), no por un id directo en cada pill.
    var selectedOptions = {};
    for (var so = 0; so < variantOptions.length; so++) {
      if (variantOptions[so].classList.contains('bs-product-hero__variant-option--selected')) {
        selectedOptions[variantOptions[so].getAttribute('data-option-position')] =
          variantOptions[so].getAttribute('data-value');
      }
    }
    var priceCurrentEl = container.querySelector('[data-bs-price-current]');
    var priceOldEl = container.querySelector('[data-bs-price-old]');
    var discountEl = container.querySelector('[data-bs-discount]');
    var priceIvaEl = container.querySelector('[data-bs-price-iva]');
    var addBtn = container.querySelector('[data-bs-add]');
    var addLabel = container.querySelector('[data-bs-add-label]');
    var addSep = container.querySelector('[data-bs-add-sep]');
    var addPrice = container.querySelector('[data-bs-add-price]');
    var qtyInput = container.querySelector('[data-bs-qty-input]');
    var qtyMinus = container.querySelector('[data-bs-qty-minus]');
    var qtyPlus = container.querySelector('[data-bs-qty-plus]');
    var qtyMsg = container.querySelector('[data-bs-qty-msg]');
    var stockEl = container.querySelector('[data-bs-stock]');
    var stockText = container.querySelector('[data-bs-stock-text]');
    var addError = container.querySelector('[data-bs-add-error]');
    var installmentsEl = container.querySelector('[data-bs-installments]');
    var qtyMsgTimer;

    // Checkbox IVA 4% (certificado discapacidad): PREVIEW visual del precio con IVA reducido.
    // El descuento real NO se aplica solo (lo aplica el comercio a mano tras validar el
    // certificado, ver card .bs-product-hero__tax-cert) — esto solo recalcula lo que se
    // muestra en pantalla como gancho visual.
    var taxCert = container.querySelector('[data-bs-tax-cert]');
    var ivaStandard = taxCert ? parseFloat(taxCert.getAttribute('data-iva-standard')) : NaN;
    var ivaReducido = taxCert ? parseFloat(taxCert.getAttribute('data-iva-reducido')) : NaN;
    var ivaFactor = (100 + ivaReducido) / (100 + ivaStandard);
    if (isNaN(ivaFactor) || ivaFactor <= 0) ivaFactor = 1;

    // Precio unitario a mostrar: con el checkbox IVA marcado, aplica el factor de IVA reducido.
    function shownUnitPrice(vv) {
      var base = vv ? vv.price : 0;
      return (taxCert && taxCert.checked) ? Math.round(base * ivaFactor) : base;
    }

    // Entrega estimada (una vez): calcula la fecha, sobrescribe data-in-text (que reutiliza
    // updateStock al cambiar de variante) y refresca el texto visible si hay stock ahora.
    if (stockEl) {
      var bsDeliv = bsDeliveryText(stockEl);
      if (bsDeliv) {
        var bsInLabel = stockEl.getAttribute('data-in-label') || '';
        // "En Stock" en su span (azul); las fechas ya vienen en spans desde bsDeliveryText.
        var bsLabelHtml = bsInLabel ? '<span class="bs-product-hero__stock-label">' + bsInLabel + '</span> · ' : '';
        var bsInText = bsLabelHtml + bsDeliv;
        stockEl.setAttribute('data-in-text', bsInText);
        if (stockText && !stockEl.classList.contains('bs-product-hero__stock--out')) {
          stockText.innerHTML = bsInText;
        }
      }
    }

    function currentVariant() {
      return variantIdInput ? variantsById[String(variantIdInput.value)] : null;
    }

    function getQty() {
      var q = parseInt(qtyInput ? qtyInput.value : '1', 10);
      return isNaN(q) ? 1 : q;
    }

    // El precio y el botón usan innerHTML porque el money_format de la tienda (confiable,
    // no input de usuario) puede traer entidades (&nbsp;) o <span> del formato de moneda.
    function updateAddButton() {
      if (!addBtn) return;
      var vv = currentVariant();
      if (!vv) {
        // Combinación de opciones inexistente (ej: Talla M + Lado que no se fabrica) → no hay
        // variante que añadir. Se deshabilita el botón con el texto de agotado.
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = addBtn.getAttribute('data-soldout-text');
        if (addSep) addSep.hidden = true;
        if (addPrice) addPrice.hidden = true;
      } else if (vv.available === false) {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = addBtn.getAttribute('data-soldout-text');
        if (addSep) addSep.hidden = true;
        if (addPrice) addPrice.hidden = true;
      } else if (vv.price === 0) {
        // TODO TANDA 2: flujo real de cotización B2B. De momento CTA informativo deshabilitado.
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = addBtn.getAttribute('data-quote-text');
        if (addSep) addSep.hidden = true;
        if (addPrice) addPrice.hidden = true;
      } else {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = addBtn.getAttribute('data-add-text');
        if (addSep) addSep.hidden = false;
        if (addPrice) {
          addPrice.hidden = false;
          addPrice.innerHTML = formatMoney(shownUnitPrice(vv) * getQty(), moneyFormat);
        }
      }
    }

    function updatePriceDisplay(vv) {
      if (!vv) return;
      if (priceCurrentEl) priceCurrentEl.innerHTML = formatMoney(shownUnitPrice(vv), moneyFormat);

      var ivaChecked = !!(taxCert && taxCert.checked);
      if (ivaChecked) {
        // Preview IVA reducido: oculta compare-at/descuento para no mezclarlo con otro badge de precio.
        if (priceOldEl) priceOldEl.hidden = true;
        if (discountEl) discountEl.hidden = true;
        if (priceIvaEl) priceIvaEl.hidden = false;
        return;
      }
      if (priceIvaEl) priceIvaEl.hidden = true;

      var hasCompare = vv.compare_at_price && vv.compare_at_price > vv.price;
      if (priceOldEl) {
        priceOldEl.hidden = !hasCompare;
        if (hasCompare) priceOldEl.innerHTML = formatMoney(vv.compare_at_price, moneyFormat);
      }
      if (discountEl) {
        discountEl.hidden = !hasCompare;
        if (hasCompare) {
          var pct = Math.round((vv.compare_at_price - vv.price) / vv.compare_at_price * 100);
          discountEl.textContent = pct + '% de descuento';
        }
      }
    }

    // Financiación: recalcula la cuota (precio ÷ plazos) al cambiar de variante, desde la
    // plantilla con %CUOTA%/%PLAZOS%. Se reconstruye por NODOS (no innerHTML) = seguro: el importe
    // (+ la unidad "/mes" que le siga) va en un <strong> para verse en negrita; el resto, texto plano.
    function updateInstallments(vv) {
      if (!installmentsEl || !vv) return;
      var tmpl = installmentsEl.getAttribute('data-installments-tmpl');
      var plazos = parseInt(installmentsEl.getAttribute('data-installments-plazos'), 10);
      if (!tmpl || !plazos || plazos <= 0) return;
      // shownUnitPrice: si el IVA 4% está marcado, la cuota se calcula sobre el precio reducido.
      var cuota = formatMoney(Math.floor(shownUnitPrice(vv) / plazos), moneyFormat);
      var withPlazos = tmpl.replace('%PLAZOS%', plazos);
      installmentsEl.textContent = '';
      var idx = withPlazos.indexOf('%CUOTA%');
      if (idx === -1) {
        installmentsEl.textContent = withPlazos;
        return;
      }
      var before = withPlazos.slice(0, idx);
      var after = withPlazos.slice(idx + 7); // '%CUOTA%'.length === 7
      var unit = '';
      var unitMatch = after.match(/^\/\S+/); // "/mes" pegado tras el importe
      if (unitMatch) {
        unit = unitMatch[0];
        after = after.slice(unit.length);
      }
      installmentsEl.appendChild(document.createTextNode(before));
      var strong = document.createElement('strong');
      strong.className = 'bs-product-hero__installments-amount';
      strong.textContent = cuota + unit;
      installmentsEl.appendChild(strong);
      installmentsEl.appendChild(document.createTextNode(after));
    }

    function applyQtyRule(vv) {
      if (!qtyInput || !vv) return;
      qtyInput.setAttribute('data-min', vv.qty_min);
      qtyInput.setAttribute('data-step', vv.qty_increment);
      if (vv.qty_max != null) {
        qtyInput.setAttribute('data-max', vv.qty_max);
      } else {
        qtyInput.removeAttribute('data-max');
      }
      qtyInput.value = vv.qty_min; // reset a la cantidad mínima de la nueva variante
    }

    function updateStock(vv) {
      if (!stockEl || !stockText || !vv) return;
      if (vv.available) {
        // innerHTML: data-in-text lleva los spans (label azul + fechas en negrita).
        stockText.innerHTML = stockEl.getAttribute('data-in-text');
        stockEl.classList.remove('bs-product-hero__stock--out');
      } else {
        stockText.textContent = stockEl.getAttribute('data-out-text');
        stockEl.classList.add('bs-product-hero__stock--out');
      }
    }

    // Resuelve la variante que casa con TODOS los valores seleccionados (por posición de opción).
    // v.options es el array de valores de la variante: ["M","Izquierda"]. Devuelve null si la
    // combinación no existe (no todas las combinaciones de opciones tienen variante).
    function resolveVariant() {
      var positions = Object.keys(selectedOptions);
      for (var vi = 0; vi < data.variants.length; vi++) {
        var vv = data.variants[vi];
        var opts = vv.options || [];
        var ok = true;
        for (var pi = 0; pi < positions.length; pi++) {
          var pos = positions[pi];
          if (opts[parseInt(pos, 10) - 1] !== selectedOptions[pos]) { ok = false; break; }
        }
        if (ok) return vv;
      }
      return null;
    }

    // ¿Existe una variante DISPONIBLE con este valor en esta posición, manteniendo el resto de
    // opciones en su selección actual? Sirve para agrisar pills cuya combinación no se puede comprar.
    function comboAvailable(pos, value) {
      for (var vi = 0; vi < data.variants.length; vi++) {
        var vv = data.variants[vi];
        var opts = vv.options || [];
        if (opts[parseInt(pos, 10) - 1] !== value) continue;
        var ok = true;
        for (var op in selectedOptions) {
          if (op === pos) continue;
          if (opts[parseInt(op, 10) - 1] !== selectedOptions[op]) { ok = false; break; }
        }
        if (ok && vv.available) return true;
      }
      return false;
    }

    // Marca [data-unavailable] en las pills cuya combinación (con el resto de opciones fijadas)
    // no existe o está agotada. Con 1 sola opción equivale a "esa variante no está disponible".
    function refreshOptionAvailability() {
      for (var i = 0; i < variantOptions.length; i++) {
        var p = variantOptions[i];
        if (comboAvailable(p.getAttribute('data-option-position'), p.getAttribute('data-value'))) {
          p.removeAttribute('data-unavailable');
        } else {
          p.setAttribute('data-unavailable', 'true');
        }
      }
    }

    // Aplica la variante resuelta al buy-box (input + precio + cuota + regla cantidad + stock + botón).
    // Si es null (combinación inexistente) NO tocamos precio/stock, vaciamos el id y deshabilitamos
    // el botón (updateAddButton detecta el id vacío).
    function applyVariant(vv) {
      if (addError) addError.hidden = true;
      if (vv) {
        if (variantIdInput) variantIdInput.value = vv.id;
        updatePriceDisplay(vv);
        updateInstallments(vv);
        applyQtyRule(vv);
        updateStock(vv);
      } else if (variantIdInput) {
        variantIdInput.value = '';
      }
      updateAddButton();
    }

    // Click en una pill: fija el valor de SU opción, actualiza el estado visual de ese grupo y el
    // texto "current", resuelve la variante por la combinación y refresca disponibilidad.
    function selectOptionValue(btn) {
      var pos = btn.getAttribute('data-option-position');
      var val = btn.getAttribute('data-value');
      selectedOptions[pos] = val;
      for (var i = 0; i < variantOptions.length; i++) {
        if (variantOptions[i].getAttribute('data-option-position') !== pos) continue;
        var on = variantOptions[i] === btn;
        variantOptions[i].classList.toggle('bs-product-hero__variant-option--selected', on);
        variantOptions[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      for (var c = 0; c < variantCurrents.length; c++) {
        if (variantCurrents[c].getAttribute('data-option-position') === pos) {
          variantCurrents[c].textContent = val;
        }
      }
      applyVariant(resolveVariant());
      refreshOptionAvailability();
    }

    function showQtyMsg(text) {
      if (!qtyMsg) return;
      qtyMsg.textContent = text;
      qtyMsg.hidden = false;
      clearTimeout(qtyMsgTimer);
      qtyMsgTimer = setTimeout(function () { qtyMsg.hidden = true; }, 3000);
    }

    function stepQty(dir) {
      if (!qtyInput) return;
      var min = parseInt(qtyInput.getAttribute('data-min'), 10) || 1;
      var step = parseInt(qtyInput.getAttribute('data-step'), 10) || 1;
      var maxRaw = qtyInput.getAttribute('data-max');
      var max = maxRaw != null ? parseInt(maxRaw, 10) : null;
      if (addError) addError.hidden = true;
      var next = getQty() + dir * step;
      if (next < min) {
        showQtyMsg((data.qty_min_message || 'Mínimo %MIN%').replace('%MIN%', min));
        next = min;
      }
      if (max != null && next > max) {
        next = max;
        showQtyMsg('Máximo ' + max + ' uds');
      }
      qtyInput.value = next;
      updateAddButton();
    }

    for (var o = 0; o < variantOptions.length; o++) {
      variantOptions[o].addEventListener('click', function () {
        selectOptionValue(this);
      });
    }
    // Estado inicial de disponibilidad de las pills (según la selección que trae el server).
    refreshOptionAvailability();
    if (qtyMinus) qtyMinus.addEventListener('click', function () { stepQty(-1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { stepQty(1); });

    // Checkbox IVA 4% (certificado discapacidad): habilita/deshabilita el line item property,
    // muestra la nota y recalcula el precio mostrado (preview, ver shownUnitPrice arriba).
    // La exención fiscal real la aplica Shopify (app/tax overrides) o el comercio a mano, no el theme.
    var certProp = container.querySelector('[data-bs-cert-prop]');
    var taxNote = container.querySelector('[data-bs-tax-note]');
    if (taxCert) {
      taxCert.addEventListener('change', function () {
        if (certProp) certProp.disabled = !taxCert.checked; // disabled → no viaja en el FormData
        // Clase (no atributo hidden) para animar la aparición/desaparición del card vía CSS.
        if (taxNote) taxNote.classList.toggle('bs-product-hero__tax-cert--visible', taxCert.checked);
        updatePriceDisplay(currentVariant());
        updateAddButton();
        updateInstallments(currentVariant());
      });
    }

    // "X opiniones" del rating → scroll suave al bloque de reseñas (sección bs-product-reviews).
    // El href="#bs-product-reviews" ya funciona sin JS (salto nativo); aquí solo lo suavizamos.
    var reviewsLink = container.querySelector('[data-bs-reviews-link]');
    if (reviewsLink) {
      reviewsLink.addEventListener('click', function (e) {
        var target = document.getElementById('bs-product-reviews');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // Sincroniza el precio del botón al cargar (cantidad inicial = mínimo de la variante).
    updateAddButton();

    // Feedback de add-to-cart: product-form-component (Horizon) dispara cart:error si el add
    // falla (p.ej. stock insuficiente → 422). Sin esto el botón "no hacía nada" visible.
    // El evento burbujea desde el form → este container, así que queda scoped a esta section.
    container.addEventListener('cart:error', function (e) {
      if (!addError) return;
      var d = e && e.detail && e.detail.data;
      addError.textContent = (d && (d.description || d.message)) || 'No se pudo añadir al carrito.';
      addError.hidden = false;
    });
    container.addEventListener('cart:update', function () {
      if (addError) addError.hidden = true;
    });
  }

  // ===== Lightbox de vídeo: clona el <template> del media pulsado dentro del modal. =====
  // El modal se porta a document.body en el primer open (escapa del overflow:clip de la
  // section y del stacking context de la galería sticky — ver comentario CSS). Devuelve
  // la función openVideo para que initGallery la use en las miniaturas de vídeo.
  function initVideoLightbox(container) {
    var modal = container.querySelector('[data-bs-video-modal]');
    var mount = modal ? modal.querySelector('[data-bs-video-mount]') : null;
    if (!modal || !mount) return null;

    var closeEls = modal.querySelectorAll('[data-bs-video-close]');
    var dialog = modal.querySelector('.bs-product-hero__video-dialog');
    var lastFocused = null;
    var isOpen = false;
    var portaled = false;

    function ensurePortal() {
      if (portaled) return;
      document.body.appendChild(modal);
      portaled = true;
    }

    // Vaciar el mount PARA el <video>/iframe: quitarlo del DOM detiene la reproducción,
    // a diferencia de solo ocultarlo con hidden.
    function stopMedia() {
      mount.innerHTML = '';
    }

    function playMedia() {
      var video = mount.querySelector('video');
      if (video) {
        // catch: si el navegador bloquea el autoplay, el usuario ya ve los controles.
        video.play().catch(function () {});
        return;
      }
      var iframe = mount.querySelector('iframe');
      if (iframe && iframe.src.indexOf('autoplay') === -1) {
        var sep = iframe.src.indexOf('?') === -1 ? '?' : '&';
        iframe.src = iframe.src + sep + 'autoplay=1';
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeVideo();
        return;
      }
      if (e.key !== 'Tab' || !dialog) return;
      // Focus trap básico: cicla entre el botón cerrar y el player.
      var focusables = dialog.querySelectorAll('button, video, iframe, [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function openVideo(mediaId, trigger) {
      var template = container.querySelector('[data-bs-video-player="' + mediaId + '"]');
      if (!template) return;
      ensurePortal();

      lastFocused = trigger || document.activeElement;
      stopMedia();
      mount.appendChild(template.content.cloneNode(true));

      modal.hidden = false;
      isOpen = true;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);

      // play() sincrono (mismo turno que el click) para no perder el gesto de usuario
      // que exigen las políticas de autoplay de los navegadores.
      playMedia();

      requestAnimationFrame(function () {
        var closeBtn = modal.querySelector('.bs-product-hero__video-close');
        if (closeBtn) closeBtn.focus();
      });
    }

    function closeVideo() {
      if (!isOpen) return;
      isOpen = false;
      modal.hidden = true;
      stopMedia();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      var target = lastFocused && lastFocused.focus ? lastFocused : null;
      if (target) {
        try { target.focus(); } catch (e) { /* noop */ }
      }
    }

    for (var i = 0; i < closeEls.length; i++) {
      closeEls[i].addEventListener('click', closeVideo);
    }

    var videoTrigger = container.querySelector('[data-bs-video-trigger]');
    if (videoTrigger) {
      videoTrigger.addEventListener('click', function () {
        openVideo(videoTrigger.getAttribute('data-bs-video-open'), videoTrigger);
      });
    }

    return openVideo;
  }

  // ===== Carrusel de reseñas (placeholder Judge.me): alterna el slide visible. =====
  // Cada slide trae sus propios dots/nav con el estado activo ya marcado por el server,
  // por eso solo togglamos la visibilidad (el dot activo lo pinta el slide correcto).
  // Sin animación de por medio → cumple prefers-reduced-motion sin código extra.
  function initReviews(container) {
    var reviews = container.querySelectorAll('[data-bs-review]');
    if (reviews.length < 2) return; // 0-1 reseñas: no hay nada que rotar.
    var current = 0;

    function show(idx) {
      idx = (idx % reviews.length + reviews.length) % reviews.length;
      for (var i = 0; i < reviews.length; i++) {
        reviews[i].hidden = i !== idx;
      }
      current = idx;
      // Reinicia el fade SOLO en el texto (cita + autor) de la reseña visible. Los controles
      // del carrusel (dots/flecha) no llevan la clase → no se re-animan. remove + reflow + add
      // fuerza el reinicio de la animación aunque la clase ya estuviera puesta.
      var fadeEls = reviews[idx].querySelectorAll('.bs-product-hero__review-quote, .bs-product-hero__review-author');
      for (var f = 0; f < fadeEls.length; f++) {
        fadeEls[f].classList.remove('bs-product-hero__review-fade');
        void fadeEls[f].offsetWidth;
        fadeEls[f].classList.add('bs-product-hero__review-fade');
      }
    }

    // Dots: salto directo al índice. (Hay un grupo por slide, pero solo el visible es clicable.)
    var dots = container.querySelectorAll('[data-bs-review-dot]');
    for (var d = 0; d < dots.length; d++) {
      dots[d].addEventListener('click', function () {
        show(parseInt(this.getAttribute('data-index'), 10));
      });
    }

    // Botón nav: avanza a la siguiente reseña (con wrap al llegar al final).
    var navs = container.querySelectorAll('[data-bs-review-next]');
    for (var n = 0; n < navs.length; n++) {
      navs[n].addEventListener('click', function () {
        show(current + 1);
      });
    }
  }

  // ===== Modal "Asistente de medidas": popup con el contenido de una página de Shopify. =====
  // Mismo patrón que initVideoLightbox (portal a document.body en el primer open, foco
  // atrapado con Tab, cierre con Escape / botón X / click en el overlay, devuelve el foco
  // al trigger al cerrar) más animación de entrada/salida (fade + scale, CSS) controlada
  // por la clase --visible: se añade un frame DESPUÉS de quitar [hidden] para que la
  // transición dispare (display:none → display:flex no anima; opacity 0→1 sí).
  function initMeasureModal(container) {
    var trigger = container.querySelector('[data-bs-measure-open]');
    var modal = container.querySelector('[data-bs-measure-modal]');
    if (!trigger || !modal) return;

    var VISIBLE_CLASS = 'bs-product-hero__measure-modal--visible';
    var dialog = modal.querySelector('.bs-product-hero__measure-dialog');
    var closeEls = modal.querySelectorAll('[data-bs-measure-close]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var CLOSE_DELAY = reduceMotion ? 0 : 250; // debe coincidir con la transition-duration del CSS
    var lastFocused = null;
    var isOpen = false;
    var portaled = false;
    var closeTimer;

    function ensurePortal() {
      if (portaled) return;
      document.body.appendChild(modal);
      portaled = true;
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeModal();
        return;
      }
      if (e.key !== 'Tab' || !dialog) return;
      // Focus trap básico: cicla entre los elementos enfocables del dialog (botón cerrar,
      // enlaces/botones del contenido de la página).
      var focusables = dialog.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function openModal() {
      ensurePortal();
      clearTimeout(closeTimer);
      lastFocused = document.activeElement;
      modal.hidden = false;
      isOpen = true;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);

      // Doble rAF: deja pintar el frame [hidden→flex, sin --visible] antes de añadir la
      // clase que dispara la transición (un solo rAF es insuficiente en algunos navegadores).
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          modal.classList.add(VISIBLE_CLASS);
        });
      });

      requestAnimationFrame(function () {
        var closeBtn = modal.querySelector('.bs-product-hero__measure-close');
        if (closeBtn) closeBtn.focus();
      });
    }

    function closeModal() {
      if (!isOpen) return;
      isOpen = false;
      modal.classList.remove(VISIBLE_CLASS);
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);

      var target = lastFocused && lastFocused.focus ? lastFocused : trigger;
      try { target.focus(); } catch (e) { /* noop */ }

      // Espera a que termine la transición de salida antes de volver a [hidden] (si se pone
      // hidden de inmediato, el fade/scale de cierre no se ve).
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        modal.hidden = true;
      }, CLOSE_DELAY);
    }

    trigger.addEventListener('click', openModal);
    for (var i = 0; i < closeEls.length; i++) {
      closeEls[i].addEventListener('click', closeModal);
    }
  }

  function initSection(container) {
    // R45: guard contra doble inicialización
    if (container.dataset.bsProductHeroInit) return;
    container.dataset.bsProductHeroInit = 'true';

    // R46: cada init busca SIEMPRE dentro de su propio container.
    var openVideo = initVideoLightbox(container);
    initGallery(container, openVideo);
    initBuyBox(container);
    initReviews(container);
    initMeasureModal(container);
  }

  // R44: querySelectorAll para todas las instancias
  var sections = document.querySelectorAll('.bs-product-hero');
  for (var k = 0; k < sections.length; k++) {
    initSection(sections[k]);
  }

  // R48: reinit en el Customizer
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.bs-product-hero');
    if (section) initSection(section);
  });
})();

/* ---------------------------------------------------------------------------
   Bloques de sin stock: mantener la variante elegida en el formulario.

   En "Avísame" y "Bajo pedido" no se renderiza el form de add-to-cart, así que
   no existe el input[name="id"] que el resto del script actualiza. Sin esto, el
   email llegaría con la variante de la carga inicial: en una silla con cuatro
   anchos de asiento, no sabrías cuál pidió el cliente.

   Se lee de [data-bs-variant-current], que ya mantiene actualizado el selector.
--------------------------------------------------------------------------- */
(function () {
  function sincronizarVariante(root) {
    var destinos = root.querySelectorAll('[data-bs-oos-variant]');
    if (!destinos.length) return;
    var actuales = root.querySelectorAll('[data-bs-variant-current]');
    if (!actuales.length) return;
    var texto = Array.prototype.map
      .call(actuales, function (el) { return (el.textContent || '').trim(); })
      .filter(Boolean)
      .join(' · ');
    if (!texto) return;
    Array.prototype.forEach.call(destinos, function (input) { input.value = texto; });
  }

  document.addEventListener('click', function (e) {
    var opcion = e.target && e.target.closest && e.target.closest('[data-bs-variant-option]');
    if (!opcion) return;
    var root = opcion.closest('.bs-product-hero') || document;
    // el selector actualiza su texto de forma asíncrona: esperamos al siguiente frame
    requestAnimationFrame(function () { sincronizarVariante(root); });
  });

  document.addEventListener('DOMContentLoaded', function () { sincronizarVariante(document); });
})();
